var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "dashboard" } },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "intro",
                  rawName: "v-intro",
                  value: _vm.$t("Guide.dashboard_guide01"),
                  expression: "$t('Guide.dashboard_guide01')",
                },
              ],
              attrs: { id: "visited", span: 12 },
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.$t("Dashboard.title01")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("Dashboard.description01")))]),
              [
                !_vm.anyCountsOf.visited
                  ? _c("p", { staticClass: "noneVisited" }, [
                      _vm._v(_vm._s(_vm.$t("Dashboard.none_data"))),
                    ])
                  : _vm._e(),
                _c("Visited", {
                  attrs: { id: "visitedGraph", height: 240 },
                  on: {
                    "counts-updated": function ($event) {
                      return _vm.onCountsUpdated("visited", $event)
                    },
                  },
                }),
              ],
            ],
            2
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "intro",
                  rawName: "v-intro",
                  value: _vm.$t("Guide.dashboard_guide02"),
                  expression: "$t('Guide.dashboard_guide02')",
                },
              ],
              attrs: { id: "today", span: 12 },
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.$t("Dashboard.title02")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("Dashboard.description02")))]),
              _c(
                "el-row",
                { staticClass: "graph" },
                [
                  _c(
                    "el-col",
                    { staticClass: "graph", attrs: { span: 12 } },
                    [
                      _c("h2", [_vm._v(_vm._s(_vm.$t("Dashboard.title05")))]),
                      !_vm.anyCountsOf.gender
                        ? _c("p", { staticClass: "none" }, [
                            _vm._v(_vm._s(_vm.$t("Dashboard.none_data"))),
                          ])
                        : _vm._e(),
                      _c("Gender", {
                        staticClass: "fixed",
                        attrs: { id: "genderGraph" },
                        on: {
                          "counts-updated": function ($event) {
                            return _vm.onCountsUpdated("gender", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "graph", attrs: { span: 12 } },
                    [
                      _c("h2", [_vm._v(_vm._s(_vm.$t("Dashboard.title06")))]),
                      !_vm.anyCountsOf.age
                        ? _c(
                            "p",
                            {
                              staticClass: "noneAge",
                              class: this.$i18n.locale,
                            },
                            [_vm._v(_vm._s(_vm.$t("Dashboard.none_data")))]
                          )
                        : _vm._e(),
                      _c("Age", {
                        staticClass: "fixed",
                        attrs: { id: "ageGraph" },
                        on: {
                          "counts-updated": function ($event) {
                            return _vm.onCountsUpdated("age", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "intro",
                  rawName: "v-intro",
                  value: _vm.$t("Guide.dashboard_guide03"),
                  expression: "$t('Guide.dashboard_guide03')",
                },
              ],
              attrs: { id: "device", span: 12 },
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.$t("Dashboard.title03")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("Dashboard.description03")))]),
              _c("Device", { ref: "device" }),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "intro",
                  rawName: "v-intro",
                  value: _vm.$t("Guide.dashboard_guide04"),
                  expression: "$t('Guide.dashboard_guide04')",
                },
              ],
              attrs: { id: "event", span: 12 },
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.$t("Dashboard.title04")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("Dashboard.description04")))]),
              _c("Event", { ref: "event" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }